// extracted by mini-css-extract-plugin
export default {"modalOverlay":"xD-z","modalContent":"yD-z","header":"zD-z","close":"AD-z"};